import { type AccordionProps } from '@capsicum/common';
import styled from 'styled-components';

import { Divider } from '../../atoms/divider/Divider';

import { AccordionItem } from './AccordionItem';

export const Accordion = ({ items }: AccordionProps) => {
	if (!items?.length) return;

	return (
		<div>
			{items?.map((item, index) => (
				<div key={item.id + index}>
					<S.Container
						$condensed={item.condensed}
						data-testid={item.testID ? `${item.testID}-container` : `accordion-itemContainer-${index}`}
					>
						<AccordionItem
							disabled={!item.content}
							icon={item.icon}
							isByDefaultExpanded={item?.isExpanded ?? false}
							testID={item.testID ? `${item.testID}-item` : `accordion-item-${item.id}`}
							title={item.title}
							titlePosition={item.titlePosition}
						>
							{item.content}
						</AccordionItem>
					</S.Container>
					{index < items.length - 1 && <Divider orientation="horizontal" testID="accordion-divider" />}
				</div>
			))}
		</div>
	);
};

namespace S {
	export const Container = styled.div<{ $condensed?: boolean }>`
		padding: ${({ $condensed, theme }) => ($condensed ? `0` : theme.spacings.small)};
	`;
}
